import { AdminMembersReportFeedsTableToolbarState } from "@/admin/insights/member-reports/tabs/discussions/AdminMembersReportFeedsTable"
import { DiscoTableUtils } from "@disco-ui/table/discoTableUtils"
import DiscoTableFilterTags from "@disco-ui/table/header/filter/DiscoTableFilterTags"
import DiscoTag from "@disco-ui/tag/DiscoTag"

type FilterTag = keyof Pick<
  AdminMembersReportFeedsTableToolbarState,
  "products" | "allCommunity"
>

interface Props {
  toolbarState: AdminMembersReportFeedsTableToolbarState
  setToolbarState: React.Dispatch<
    React.SetStateAction<Partial<AdminMembersReportFeedsTableToolbarState>>
  >
}

function AdminMembersReportFeedsTableFilterTags({
  toolbarState,
  setToolbarState,
}: Props) {
  const filterFieldNames: FilterTag[] = ["products", "allCommunity"]
  const showFilterTags = filterFieldNames.some((fieldName) => toolbarState[fieldName])

  return (
    <DiscoTableFilterTags isVisible={showFilterTags}>
      {filterFieldNames.map((fieldName) => {
        const option = toolbarState[fieldName]
        if (!option) return null

        const tags = Array.isArray(option) ? option : [option]
        return tags.map((tag) => (
          <DiscoTag
            key={`${fieldName}.${tag.value}`}
            testid={`AdminMembersReportFeedsTable.filter-tag.${fieldName}`}
            name={tag.context?.filterTagTitle || tag.title}
            onDelete={() =>
              DiscoTableUtils.handleDeleteFilterTag(
                toolbarState,
                setToolbarState,
                fieldName,
                tags,
                tag
              )
            }
          />
        ))
      })}
    </DiscoTableFilterTags>
  )
}

export default AdminMembersReportFeedsTableFilterTags
